import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import logoWhite from '../common/app2soft/images/logo_white_140X40.png';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Menu from 'material-ui/Menu';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import DropDownMenu from 'material-ui/DropDownMenu';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';

import BalanceIcon from 'material-ui/svg-icons/action/account-balance';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';

import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ContentFilter from 'material-ui/svg-icons/content/filter-list';
import FileFileDownload from 'material-ui/svg-icons/file/file-download';
import IconButton from 'material-ui/IconButton';

import './style.scss';

export default class Header extends Component {

  constructor(props){
    super(props);
    this.state = {
      hasAnimation: false,
      open: false
    }
    this.handleScroll = this.handleScroll.bind();
  }

  handleToggle = () => this.setState({open: !this.state.open});

  componentDidMount(){
    let self = this;
    this.setState({ hasAnimation: this.props.animation}, () => {
      let valid = this.state.hasAnimation;
      if( valid ){
        document.addEventListener('scroll', this.handleScroll, true);
      }
    })
  }

  handleScroll = (self) => {
    const marginTop = document.documentElement.scrollTop;
    const siteHeader = this.refs.siteHeader;

    if(siteHeader === undefined )
      return;

    if(marginTop >= 60){
      siteHeader.classList.add('active');
    }else{
      siteHeader.classList.remove('active');
    }
  }

  handleOpenMenu = () => {
    this.setState({
      openMenu: true,
    });
  }

  handleOnRequestChange = (value) => {
    this.setState({
      openMenu: value,
    });
  }

  render() {
    return (
      <header ref="siteHeader" className={`site-header ${!this.state.hasAnimation ? 'active' : ""}`}>
        <div className="wrapper">
          <div className="appBar">
            <div className="menu" onClick={this.handleToggle}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M2 13.5h14V12H2v1.5zm0-4h14V8H2v1.5zM2 4v1.5h14V4H2z"/></svg>								            </div>
            <Link to="/"><img className="logo-white" width="140" src={logoWhite} alt="Logo App2Soft" title="Logo App2Soft"/></Link>
            <Link to="/"><img className="logo" width="140" src={logo} alt="Logo App2Soft" title="Logo App2Soft"/></Link>
          </div>
          <div className="mainBarMenu">
            <ToolbarGroup>
              <Link to="/about-us"><FlatButton label="About" /></Link>
              <IconMenu iconButtonElement={
                <FlatButton label="Services" />
              }><br /><br />
              <MenuItem>
                <Link className="item" to='/services/front-end'>Front End</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/back-end'>Back End</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/mobile'>Mobile</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/microsoft'>Microsoft</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/database'>Database</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/devops'>Dev Ops</Link>
              </MenuItem>
              <MenuItem>
                <Link className="item" to='/services/ui-ux'>UI UX</Link>
              </MenuItem>
            </IconMenu>
            <Link to="/clients"><FlatButton label="Clients" /></Link>
            <Link to="/team"><FlatButton label="Team" /></Link>
            <ToolbarSeparator />
            <Link to="/build-your-team"><RaisedButton label="Build your Team" primary={true} /></Link>
          </ToolbarGroup>
        </div>
      </div>

      <div>

        <Drawer className="sideBarMenu" open={this.state.open}>
          <MenuItem className="btn-close" onClick={this.handleToggle}>
            Close X
          </MenuItem>
          <MenuItem onClick={this.handleToggle} >
            <Link to='/about-us'>About Us</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle} >
            <Link to='/clients'>Clients</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle} >
            <Link to='/team'>Team</Link>
          </MenuItem>
          <MenuItem disabled={true} >
            Development Services
          </MenuItem>
          <MenuItem onClick={this.handleToggle} >
            <Link to='/services/front-end'>Front End</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/back-end'>Back End</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/mobile'>Mobile</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/microsoft'>Microsoft</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/database'>Database</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/devops'>Dev Ops</Link>
          </MenuItem>
          <MenuItem onClick={this.handleToggle}>
            <Link className="" to='/services/ui-ux'>UI UX</Link>
          </MenuItem>

        </Drawer>
      </div>


    </header>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/header/index.js